import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Conocer el miedo",
    opening: localizedGenderNode(
      [
      "Hoy no me empujo. Solo noto: hay miedo en mi al encontrarme con gente.",
      "Estoy conmigo.",
      "Una respiracion."
    ],
      [
      "Hoy no me empujo. Solo noto: hay miedo en mi al encontrarme con gente.",
      "Estoy conmigo.",
      "Una respiracion."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiracion."
    ],
      [
      "Pauso conmigo.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que pasa en mi cuando pienso en encontrarme con gente?",
      "Que parte de mi quiere desaparecer o huir?",
      "Que necesito escuchar de mi ahora?"
    ],
      [
      "Que pasa en mi cuando pienso en encontrarme con gente?",
      "Que parte de mi quiere desaparecer o huir?",
      "Que necesito escuchar de mi ahora?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cuando lo nombro, se siente menos aterrador."
    ],
      [
      "Cuando lo nombro, se siente menos aterrador."
    ]
    ),
    action: localizedGenderNode(
      "me digo en silencio \"estoy conmigo\".",
      "me digo en silencio \"estoy conmigo\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "El primer momento",
    opening: localizedGenderNode(
      [
      "Hoy noto el primer momento en que el miedo sube.",
      "No avanzo. Solo noto.",
      "Una respiracion."
    ],
      [
      "Hoy noto el primer momento en que el miedo sube.",
      "No avanzo. Solo noto.",
      "Una respiracion."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiracion."
    ],
      [
      "Pauso conmigo.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Cuando durante el día aparece el miedo?",
      "Que es lo primero que siento en el cuerpo?",
      "Que es lo primero que salta en mi mente?"
    ],
      [
      "Cuando durante el día aparece el miedo?",
      "Que es lo primero que siento en el cuerpo?",
      "Que es lo primero que salta en mi mente?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "El primer momento es una pequeña grieta de eleccion."
    ],
      [
      "El primer momento es una pequeña grieta de eleccion."
    ]
    ),
    action: localizedGenderNode(
      "cuando sube, hago una pausa de dos respiraciones.",
      "cuando sube, hago una pausa de dos respiraciones."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "Mi cuerpo",
    opening: localizedGenderNode(
      [
      "Hoy le doy a mi cuerpo una palabra.",
      "Sin juicio. Solo descripcion.",
      "Una respiracion."
    ],
      [
      "Hoy le doy a mi cuerpo una palabra.",
      "Sin juicio. Solo descripcion.",
      "Una respiracion."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiracion."
    ],
      [
      "Pauso conmigo.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Donde se siente en mi cuerpo? (vientre / pecho / garganta)",
      "Que intenta hacer mi cuerpo por mi?",
      "Que pequeño ablandar puedo darle?"
    ],
      [
      "Donde se siente en mi cuerpo? (vientre / pecho / garganta)",
      "Que intenta hacer mi cuerpo por mi?",
      "Que pequeño ablandar puedo darle?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Mi cuerpo no esta contra mi. Intenta proteger."
    ],
      [
      "Mi cuerpo no esta contra mi. Intenta proteger."
    ]
    ),
    action: localizedGenderNode(
      "mano en mi pecho por diez segundos.",
      "mano en mi pecho por diez segundos."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "La historia en mi cabeza",
    opening: localizedGenderNode(
      [
      "Hoy separo lo que pasa de lo que me cuento.",
      "Veo la historia.",
      "Una respiracion."
    ],
      [
      "Hoy separo lo que pasa de lo que me cuento.",
      "Veo la historia.",
      "Una respiracion."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiracion."
    ],
      [
      "Pauso conmigo.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que historia me cuento sobre un encuentro?",
      "Que significado le doy a las miradas o al silencio?",
      "Que posibilidad más suave existe?"
    ],
      [
      "Que historia me cuento sobre un encuentro?",
      "Que significado le doy a las miradas o al silencio?",
      "Que posibilidad más suave existe?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una historia no es un hecho."
    ],
      [
      "Una historia no es un hecho."
    ]
    ),
    action: localizedGenderNode(
      "me digo \"esto es una historia, no una certeza\".",
      "me digo \"esto es una historia, no una certeza\"."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "Disparadores",
    opening: localizedGenderNode(
      [
      "Hoy noto lo que dispara el miedo.",
      "Es conocimiento, no culpa.",
      "Una respiracion."
    ],
      [
      "Hoy noto lo que dispara el miedo.",
      "Es conocimiento, no culpa.",
      "Una respiracion."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiracion."
    ],
      [
      "Pauso conmigo.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que tipo de lugar, persona o ruido me activa?",
      "Que lo hace más fuerte?",
      "Que lo suaviza aunque sea un poco?"
    ],
      [
      "Que tipo de lugar, persona o ruido me activa?",
      "Que lo hace más fuerte?",
      "Que lo suaviza aunque sea un poco?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cuando conozco un disparador, me sorprende menos."
    ],
      [
      "Cuando conozco un disparador, me sorprende menos."
    ]
    ),
    action: localizedGenderNode(
      "elijo un disparador y lo miro sin huir.",
      "elijo un disparador y lo miro sin huir."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "Mi patron",
    opening: localizedGenderNode(
      [
      "Hoy miro mi patron alrededor de la gente.",
      "Sin critica.",
      "Una respiracion."
    ],
      [
      "Hoy miro mi patron alrededor de la gente.",
      "Sin critica.",
      "Una respiracion."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiracion."
    ],
      [
      "Pauso conmigo.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que hago para protegerme en un encuentro?",
      "Cual es el costo de esa proteccion?",
      "Que podria ser un poco diferente?"
    ],
      [
      "Que hago para protegerme en un encuentro?",
      "Cual es el costo de esa proteccion?",
      "Que podria ser un poco diferente?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un cambio pequeño basta para aflojar un bucle."
    ],
      [
      "Un cambio pequeño basta para aflojar un bucle."
    ]
    ),
    action: localizedGenderNode(
      "me permito un cambio pequeño una vez.",
      "me permito un cambio pequeño una vez."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "Miedo al rechazo",
    opening: localizedGenderNode(
      [
      "Hoy toco el miedo de debajo.",
      "Me quedo con el un momento.",
      "Una respiracion."
    ],
      [
      "Hoy toco el miedo de debajo.",
      "Me quedo con el un momento.",
      "Una respiracion."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiracion."
    ],
      [
      "Pauso conmigo.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que es lo que más temo que pase en un encuentro?",
      "Que frase interna aparece cuando imagino rechazo?",
      "Que me ayudaria a sentirme un poco más seguro/a?"
    ],
      [
      "Que es lo que más temo que pase en un encuentro?",
      "Que frase interna aparece cuando imagino rechazo?",
      "Que me ayudaria a sentirme un poco más seguro/a?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "El miedo al rechazo es una necesidad de cercanía y seguridad."
    ],
      [
      "El miedo al rechazo es una necesidad de cercanía y seguridad."
    ]
    ),
    action: localizedGenderNode(
      "noto el miedo sin pelear con el.",
      "noto el miedo sin pelear con el."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "La voz critica",
    opening: localizedGenderNode(
      [
      "Hoy noto la voz que me critica antes de un encuentro.",
      "Escucho sin creerle.",
      "Una respiracion."
    ],
      [
      "Hoy noto la voz que me critica antes de un encuentro.",
      "Escucho sin creerle.",
      "Una respiracion."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiracion."
    ],
      [
      "Pauso conmigo.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que me dice la voz critica?",
      "Que palabra usa sobre mi?",
      "Que voz suave podria responderle?"
    ],
      [
      "Que me dice la voz critica?",
      "Que palabra usa sobre mi?",
      "Que voz suave podria responderle?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una voz critica es una voz asustada."
    ],
      [
      "Una voz critica es una voz asustada."
    ]
    ),
    action: localizedGenderNode(
      "una frase suave para mi.",
      "una frase suave para mi."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "Limite interno",
    opening: localizedGenderNode(
      [
      "Hoy pongo un limite interno en un encuentro.",
      "Para cuidarme.",
      "Una respiracion."
    ],
      [
      "Hoy pongo un limite interno en un encuentro.",
      "Para cuidarme.",
      "Una respiracion."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiracion."
    ],
      [
      "Pauso conmigo.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que no es ok para mi en espacios sociales?",
      "Como me avisa el cuerpo que es demasiado?",
      "Que limite interno puedo poner sin palabras?"
    ],
      [
      "Que no es ok para mi en espacios sociales?",
      "Como me avisa el cuerpo que es demasiado?",
      "Que limite interno puedo poner sin palabras?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un limite interno crea espacio para respirar."
    ],
      [
      "Un limite interno crea espacio para respirar."
    ]
    ),
    action: localizedGenderNode(
      "me recuerdo ese limite antes de salir.",
      "me recuerdo ese limite antes de salir."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "Lo que necesito",
    opening: localizedGenderNode(
      [
      "Hoy busco la necesidad debajo del miedo.",
      "No una solucion, solo una necesidad.",
      "Una respiracion."
    ],
      [
      "Hoy busco la necesidad debajo del miedo.",
      "No una solucion, solo una necesidad.",
      "Una respiracion."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiracion."
    ],
      [
      "Pauso conmigo.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que necesito en un encuentro para sentirme más seguro/a?",
      "Que me ayuda a sentirme visto/a sin esfuerzo?",
      "Que cosa pequeña puedo darme?"
    ],
      [
      "Que necesito en un encuentro para sentirme más seguro/a?",
      "Que me ayuda a sentirme visto/a sin esfuerzo?",
      "Que cosa pequeña puedo darme?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cuando veo una necesidad, algo se calma."
    ],
      [
      "Cuando veo una necesidad, algo se calma."
    ]
    ),
    action: localizedGenderNode(
      "me doy una cosa pequeña antes de un encuentro.",
      "me doy una cosa pequeña antes de un encuentro."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "Un pequeño pedido",
    opening: localizedGenderNode(
      [
      "Hoy formulo un pequeño pedido hacia mi.",
      "Sin presion.",
      "Una respiracion."
    ],
      [
      "Hoy formulo un pequeño pedido hacia mi.",
      "Sin presion.",
      "Una respiracion."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiracion."
    ],
      [
      "Pauso conmigo.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que pequeño pedido puedo hacerme hoy?",
      "Como suena si lo digo con suavidad?",
      "Que me ayudara a recordarlo en el momento?"
    ],
      [
      "Que pequeño pedido puedo hacerme hoy?",
      "Como suena si lo digo con suavidad?",
      "Que me ayudara a recordarlo en el momento?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un pedido suave es más amable que una orden."
    ],
      [
      "Un pedido suave es más amable que una orden."
    ]
    ),
    action: localizedGenderNode(
      "repito el pedido una vez.",
      "repito el pedido una vez."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Presencia antes del encuentro",
    opening: localizedGenderNode(
      [
      "Hoy practico presencia justo antes de entrar.",
      "Eso es suficiente por hoy.",
      "Una respiracion."
    ],
      [
      "Hoy practico presencia justo antes de entrar.",
      "Eso es suficiente por hoy.",
      "Una respiracion."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiracion."
    ],
      [
      "Pauso conmigo.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que me ayuda a recordar que no estoy solo/a por dentro?",
      "Que pequeño ancla puedo llevar conmigo?",
      "Que quiero recordar dentro del encuentro?"
    ],
      [
      "Que me ayuda a recordar que no estoy solo/a por dentro?",
      "Que pequeño ancla puedo llevar conmigo?",
      "Que quiero recordar dentro del encuentro?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "La presencia es un escudo suave."
    ],
      [
      "La presencia es un escudo suave."
    ]
    ),
    action: localizedGenderNode(
      "un ancla conmigo (una palabra / una respiracion / un toque).",
      "un ancla conmigo (una palabra / una respiracion / un toque)."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "Un pequeño paso en el espacio",
    opening: localizedGenderNode(
      [
      "Hoy elijo un pequeño paso dentro de un espacio social.",
      "No una revolucion.",
      "Una respiracion."
    ],
      [
      "Hoy elijo un pequeño paso dentro de un espacio social.",
      "No una revolucion.",
      "Una respiracion."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiracion."
    ],
      [
      "Pauso conmigo.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que pequeño paso me queda bien?",
      "Como sabre que fue suficiente aunque sea pequeño?",
      "Que me pido a mi despues de eso?"
    ],
      [
      "Que pequeño paso me queda bien?",
      "Como sabre que fue suficiente aunque sea pequeño?",
      "Que me pido a mi despues de eso?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Los pasos pequenos construyen confianza."
    ],
      [
      "Los pasos pequenos construyen confianza."
    ]
    ),
    action: localizedGenderNode(
      "un paso pequeño, y eso es suficiente.",
      "un paso pequeño, y eso es suficiente."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Frase de regreso",
    opening: localizedGenderNode(
      [
      "Hoy termino con una frase de regreso para momentos dificiles.",
      "Me quedo conmigo.",
      "Una respiracion."
    ],
      [
      "Hoy termino con una frase de regreso para momentos dificiles.",
      "Me quedo conmigo.",
      "Una respiracion."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiracion."
    ],
      [
      "Pauso conmigo.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que aprendi sobre este miedo?",
      "Que me ayuda más cuando aparece?",
      "Mi frase corta de regreso es:"
    ],
      [
      "Que aprendi sobre este miedo?",
      "Que me ayuda más cuando aparece?",
      "Mi frase corta de regreso es:"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Puedo quedarme presente un momento antes de reaccionar."
    ],
      [
      "Puedo quedarme presente un momento antes de reaccionar."
    ]
    ),
    action: localizedGenderNode(
      "digo mi frase de regreso una vez.",
      "digo mi frase de regreso una vez."
    ),
  },
].map(buildNormalizedDay);

export const fearMeetingPeopleSocialEventsBlueprintEs = buildNormalizedPilotBlueprint({
  id: "fear_meeting_people_social_events_14d",
  version: "tri_locale_emit_es_v1",
  durationDays: 14,
  problemKey: "fear_meeting_people_social_events",
  category: "anxiety",
  journeyName: {
    he: "פחד ממפגש עם אנשים / אירועים חברתיים",
    en: "Fear of meeting people / social events",
    es: "Miedo a encontrarme con gente / eventos sociales",
  },
  days,
});

export default fearMeetingPeopleSocialEventsBlueprintEs;
